export default __webpack_public_path__ + "static/media/key.f7a75038.png";